{
  "documentTitle": "Ouvrir une session dans Salt",
  "codeLabel": "Votre code d'ouverture de session"
}
